module.exports = __webpack_public_path__ + "static/media/icon_nav_on_account.d261652b.svg";